import React from 'react';
import { Col, Row } from 'components/common/grid';
import { FormattedMessage } from 'react-intl';
import styled from 'types/theme.types';
import Button from 'components/common/button';
import type { UseFormReturnType } from 'hooks/use-form.hook';

import type { VcsConnection } from './vcs-connection-modal-picker';
import { getAzureDevOpsAuthenticationTypeInUse } from './access-card/supported-vcs-connections-common';

export const VcsConnectionModalButtons: React.FC<{
  form: UseFormReturnType;
  vcsConnection: VcsConnection;
  onSave: () => void;
  isPending?: boolean;
}> = ({ form, vcsConnection, onSave, isPending = false }) => {
  // The popup already switched the token and synced the connection, so there is nothing left to submit
  const isAzureDevOpsSwitch = !!getAzureDevOpsAuthenticationTypeInUse(vcsConnection);

  return (
    <Row gutter={8}>
      <Col span={6}>
        <ButtonStyled
          data-e2e="save-vcs-connection-button"
          isLoading={form.isSubmitting || isPending}
          type="primary"
          onClick={async () => {
            if (!isAzureDevOpsSwitch) await form.submit();
            onSave();
          }}
          disabled={!form.canSave || form.isSubmitting || isPending}>
          <ButtonContainer>
            <FormattedMessage
              id={isAzureDevOpsSwitch ? 'done' : 'organization.settings.agents.vcs-connections-modal.save-button'}
            />
          </ButtonContainer>
        </ButtonStyled>
      </Col>
    </Row>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

const ButtonStyled = styled(Button)`
  width: 100%;
`;
